import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import BaseMenu from './BaseMenu';
import BaseUISystem from '../BaseUISystem';
import { UIActions } from '../../../State/UI/UIActions';
import Game from '../../../Game';
import UITextComponent from '../../../Component/UI/Text';
import Renderable from '../../../Component/Renderable';
import { GameActions } from '../../../State/Game/GameActions';
import { StartAnimation } from '../../Animation/AnimationHelper';
import ElementComponent from '../../../Component/UI/Element';
import LeaderboardHelper from '../LeaderboardHelper';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import {
    applyBounceButtonAnimation,
    applyDefaultButtonAnimation,
} from '../UIHelper';
import { IWinCriteriaData, WinCriteriaType } from '../../../State/Level/ILevelState';
import { WinCriteriaTypeMap } from '../../../Constants/WinCriteria';

const BTN_CLOSE: string = 'main_container/close_button';
const BTN_PLAY: string = 'main_container/play_button';
const TXT_TITLE: string = 'main_container/title_container/title_text';
const STARS: string = 'main_container/star_container';
const TOP_LIST: string = 'toplist';
const TXT_GOAL: string = 'main_container/goal_container/goal_cover/goal_text';
const ICON_GOAL: string = 'main_container/goal_container/goal_cover/goal_icon_';

export default class LevelMenuHandler extends BaseMenu {
    private levelNumber: number;
    private levelPath: string;
    private goals: IWinCriteriaData[];
    private stars: Renderable[];

    constructor(uiSystem: BaseUISystem) {
        super('levelMenu', uiSystem);
    }

    protected onCreate() {
        // Get "full" stars.
        const stars = this.element.find(STARS);
        if (stars) {
            this.stars = [];
            stars.children.forEach(child => {
                this.stars.push(child.children[1].getComponent(Renderable));
            });
        }

        // Button close.
        const btnClose = this.element.find(BTN_CLOSE);
        if (btnClose) {
            btnClose.on(GameObjectEvent.SELECTED, () => {
                this.system.state.dispatch(
                    UIActions.hidePopup(this.name, {
                        level: this.levelNumber,
                    })
                );
            });
            applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);
        }

        // Button play.
        const btnPlay = this.element.find(BTN_PLAY);
        if (btnPlay) {
            btnPlay.on(GameObjectEvent.SELECTED, () => {
                if (this.levelNumber === 2) {
                    Game.sdk.gameTracking(
                        FBTrackingEvent.FTUE_10a_Level2PreLevelButtonPlay
                    );
                }

                if (this.levelNumber === 3) {
                    Game.sdk.gameTracking(
                        FBTrackingEvent.FTUE_20a_Level3PreLevelButtonPlay
                    );
                }

                Game.state.dispatch(
                    GameActions.loadLevel(
                        this.levelNumber,
                        `${Game.config.levelBasePath}/${this.levelPath}`
                    )
                );
            });
            applyBounceButtonAnimation(btnPlay, AUDIO_UI_BUTTON_DEFAULT);
        }
    }

    protected onShow(params?: any): void {
        this.setup(params.level, params.path, params.goals);

        const topList = this.element.find(TOP_LIST);
        if (topList) {
            LeaderboardHelper.loadLevelMenuLeaderboard(
                topList,
                params.level.toString()
            );
            topList.getComponent(ElementComponent).pivot.x = 1;
        }
    }

    protected onShown(): void {
        const topList = this.element.find(TOP_LIST);
        if (topList && Game.sdk.driver.hasSocialFeaturesSupport()) {
            StartAnimation(this.element.find(TOP_LIST), 'TopList');
        }
    }

    protected onHide(params?: any): void {
        this.setup(this.levelNumber, this.levelPath, this.goals);
    }

    private setup(
        levelNumber: number,
        levelPath: string,
        goals: IWinCriteriaData[]
    ): void {
        this.levelNumber = levelNumber;
        this.levelPath = levelPath;

        if (goals) {
            this.goals = goals;
        }

        // Update the title with the current level.
        const title = this.element.find(TXT_TITLE);
        title.getComponent(UITextComponent).text = Game.locale
            .getText('Level')
            .replace('[x]', this.levelNumber.toString());

        // Update the "full" stars.
        const levelStars = Game.player.getLevelStars(this.levelNumber);
        this.stars.forEach((star, index) => {
            star.visible = index < levelStars;
        });

        // Update the goal message
        const goal = this.element.find(TXT_GOAL);
        const textKey = WinCriteriaTypeMap[this.goals[0].type].textKey;
        const text = Game.locale.getText(textKey);
        goal.getComponent(UITextComponent).text = text;

        // Update the goal icon
        const icon = this.element.find(ICON_GOAL + this.goals[0].type);
        icon.getComponent(Renderable).visible = true;
    }
}
